import script from "./AIAssistantButton.vue?vue&type=script&setup=true&lang=js"
export * from "./AIAssistantButton.vue?vue&type=script&setup=true&lang=js"

import "./AIAssistantButton.vue?vue&type=style&index=0&id=90945fae&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90945fae"]])

export default __exports__